// External Dependencies
import { useMatch } from 'react-router-dom';
import type { FC, ReactElement } from 'react';
import type { MenuItemProps } from '@mui/material/MenuItem';
import type { OverridableComponent } from '@mui/material/OverridableComponent';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon';

// Local Dependencies
import EnhancedMenuItem from './EnhancedMenuItem';

// Local Typings
export interface NavMenuItemProps extends MenuItemProps {
  className?: string;
  contentRef?: React.Ref<HTMLDivElement>;
  icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  isActive?: boolean;
  match?: string;
  onClick?: () => void;
  text?: string | ReactElement;
  to: string;
}

// Component Definition
const NavMenuItem: FC<NavMenuItemProps> = ({
  isActive,
  match,
  text,
  to,
  ...props
}) => {
  const getBasePath = (path: string | undefined): string => path?.split('?')[0] || '';

  const cleanPath = getBasePath(match) || getBasePath(to);
  const isMatched = useMatch(`${cleanPath}/*`);

  return (
    <EnhancedMenuItem
      isActive={isActive || Boolean(isMatched)}
      text={text}
      to={to}
      {...props}
    />
  );
};

export default NavMenuItem;
